/**
 * SELVANE Cart Custom Injector (v6.0 - Key+Qty+VariantId stable)
 */
(function () {
  const cleanText = (s) => (s || "").replace(/[\n\r\t]/g, " ").replace(/\s+/g, " ").trim();

  const extractColorFromOptionCart = (labelEl) => {
    let currentColor = "";
    const optionCart = labelEl.closest(".product_option-cart");
    if (!optionCart) return "";
    const parentText = cleanText(optionCart.textContent);
    const colorMatch = parentText.match(/Color:\s*(.+?)\s*Size:/i);
    if (colorMatch) currentColor = cleanText(colorMatch[1]).replace(/,\s*$/, "");
    return currentColor;
  };

  const extractCartPageKeyFromRemoveUrl = (container) => {
    // Cart page has <a href="/cart/change?id=KEY&quantity=0">
    const removeLink = container.querySelector('a[href*="/cart/change"]');
    if (!removeLink) return "";
    const href = removeLink.getAttribute("href") || "";
    const m = href.match(/id=([^&]+)/);
    return m ? m[1] : "";
  };

  const injectAdjustSize = () => {
    const sizeLabels = document.querySelectorAll(".product-option.d-inline-flex:not(.selvane-injected)");

    sizeLabels.forEach((label) => {
      const text = cleanText(label.textContent);
      const isSize = /^(XS|S|M|L|XL|XXL|XXXL|[0-9]+)$/i.test(text);
      if (!isSize) return;

      const container =
        label.closest(".cart-item") ||
        label.closest("[data-cart-item]") ||
        label.closest("#CartDrawer-CartItems")?.querySelector(".cart-item") ||
        label.parentElement;

      if (!container) return;

      const productLink = container.querySelector('a[href*="/products/"]');
      if (!productLink) return;

      let handle = (productLink.getAttribute("href") || "").split("/products/")[1] || "";
      handle = handle.split("?")[0].split("#")[0].replace(/\/$/, "");
      if (!handle) return;

      const title =
        container.querySelector(".product-name, .cart-item__name, .cart-item__title, .product__name")?.textContent?.trim() ||
        "Product";
      const image = container.querySelector("img")?.src || "";

      const currentColor = extractColorFromOptionCart(label);

      // qty / variant / key
      const quantityInput = container.querySelector('input[name="updates[]"]');
      const currentQty = quantityInput ? parseInt(quantityInput.value || "1", 10) : 1;
      const variantId = quantityInput?.getAttribute("data-quantity-variant-id") || "";

      const isCartPage = window.location.pathname === "/cart" || window.location.pathname.includes("/cart");
      const lineItemKey = isCartPage ? extractCartPageKeyFromRemoveUrl(container) : "";

      const environment = isCartPage ? "cart" : "drawer";

      const btn = document.createElement("a");
      btn.href = "#";
      btn.className = "selvane-adjust-size-trigger-v3";
      btn.textContent = "Adjust size";

      btn.setAttribute("data-selvane-change-size-open", "");
      btn.setAttribute("data-product-handle", handle);
      btn.setAttribute("data-product-title", title);
      btn.setAttribute("data-product-image", image);
      btn.setAttribute("data-current-size", text);
      btn.setAttribute("data-current-color", currentColor);
      btn.setAttribute("data-variant-id", variantId); // always variant id
      btn.setAttribute("data-line-item-key", lineItemKey); // cart page filled, drawer empty (we’ll resolve via /cart.js)
      btn.setAttribute("data-current-qty", String(isNaN(currentQty) ? 1 : currentQty));
      btn.setAttribute("data-environment", environment);

      label.style.alignItems = "baseline";
      btn.style.marginLeft = "10px";
      btn.style.textDecoration = "underline";
      btn.style.textUnderlineOffset = "3px";
      btn.style.color = "#666";
      btn.style.cursor = "pointer";
      btn.style.fontSize = "11px";
      btn.style.fontFamily = "Futura, sans-serif";
      btn.style.display = "inline-block";
      btn.style.lineHeight = "1";
      btn.style.textTransform = "none";

      label.appendChild(btn);
      label.classList.add("selvane-injected");

      console.log(
        "SELVANE: Injected |",
        { handle, size: text, color: currentColor, environment, variantId, lineItemKey, qty: currentQty }
      );
    });
  };

  injectAdjustSize();
  const observer = new MutationObserver(() => injectAdjustSize());
  observer.observe(document.body, { childList: true, subtree: true });
})();
